import { MessageCircle, Phone } from 'lucide-react';

import { siteConfig } from '../../../shared/config/site';

export function StickyCallDock() {
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:px-4">
      <div className="pointer-events-auto mx-auto flex max-w-md items-center gap-2 rounded-xl border border-primary-400/35 bg-neutral-950/95 p-2 shadow-2xl backdrop-blur-md">
        <a
          href={siteConfig.phoneHref}
          className="inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-lg bg-primary-400 px-4 text-sm font-semibold text-neutral-950 transition hover:bg-primary-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 sm:text-base"
          aria-label={`Call the yard on ${siteConfig.phoneDisplay}`}
        >
          <Phone className="h-4 w-4" aria-hidden="true" />
          Call the yard
        </a>
        <a
          href={siteConfig.whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-lg border border-white/25 bg-neutral-900 text-white transition hover:border-primary-400/50 hover:bg-neutral-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
          aria-label="WhatsApp the yard"
        >
          <MessageCircle className="h-5 w-5" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}
